import axios from '../../../helpers/custom-axios';
import { notify, confirmation } from '../../../helpers/notifications';

export const defaultValues = {
  display_name: '',
  name: '',
  slug: '',
  active: true,
};

export const handleCreateContainer = async (formData) => {
  return axios
    .post('/manage/containers', {
      container: { ...formData },
    })
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const handleEditContainer = async (formData, id) => {
  return axios
    .put(`/manage/containers/${id}`, formData)
    .then((res) => {
      notify.saved();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const handleDestroyContainer = async (container, callback) => {
  confirmation.destroy(async () => {
    return axios
      .delete(`/manage/containers/${container.id}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      });
  });
};
